import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasToken } from '../utils/tokenStorage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Check for JWT token instead of user
  if (!hasToken()) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
